import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';
import { formatINR } from '../../lib/emi';

const ResultRow = ({ label, value, testId }) => (
  <div className="flex justify-between items-center pb-3 border-b border-white/20">
    <span className="text-cyan-100">{label}</span>
    <span className="font-semibold" data-testid={testId}>{value}</span>
  </div>
);

export const EMIResult = ({ amount, emi, totalInterest, totalPayment, principalPct, onApply }) => (
  <div className="p-8 bg-gradient-to-br from-cyan-600 to-teal-700 text-white flex flex-col justify-center">
    <div className="text-center mb-8">
      <p className="text-cyan-100 text-sm uppercase tracking-wide mb-2">Your Monthly EMI</p>
      <p className="text-4xl sm:text-5xl font-bold" data-testid="emi-monthly-result">{formatINR(emi)}</p>
    </div>

    <div className="space-y-4 mb-8">
      <ResultRow label="Principal Amount" value={formatINR(amount)} testId="emi-principal-result" />
      <ResultRow label="Total Interest" value={formatINR(totalInterest)} testId="emi-interest-result" />
      <ResultRow label="Total Payment" value={formatINR(totalPayment)} testId="emi-total-result" />

      <div className="w-full h-3 bg-white/20 rounded-full overflow-hidden flex" title="Principal vs Interest">
        <div className="h-full bg-white" style={{ width: `${principalPct}%` }} />
        <div className="h-full bg-amber-400" style={{ width: `${100 - principalPct}%` }} />
      </div>
      <div className="flex justify-between text-xs text-cyan-100">
        <span className="flex items-center gap-1.5">
          <span className="w-2.5 h-2.5 rounded-full bg-white inline-block" />
          Principal {principalPct.toFixed(0)}%
        </span>
        <span className="flex items-center gap-1.5 text-amber-200">
          <span className="w-2.5 h-2.5 rounded-full bg-amber-400 inline-block" />
          Interest {(100 - principalPct).toFixed(0)}%
        </span>
      </div>
    </div>

    <Link to="/contact" onClick={onApply}>
      <Button size="lg" className="w-full bg-white text-cyan-700 hover:bg-cyan-50 font-semibold" data-testid="emi-apply-btn">
        Apply for This Loan
        <ArrowRight className="ml-2 w-4 h-4" />
      </Button>
    </Link>
    <p className="text-xs text-cyan-200 text-center mt-3">
      *Indicative calculation. Actual rates subject to CIBIL &amp; documentation.
    </p>
  </div>
);

export default EMIResult;
